<template>
  <b-modal
      id="update-share-person"
      :title=" _.get(shareRecord, 'sperson.id') + ' shared with ' + _.get(shareRecord, 'sgroup.groupName') "
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
      @hidden="reset"
    >
    <b-row>
      <b-col>
        <br>
        <b>Created At: </b> {{ $moment.unix(_.get(shareRecord, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Last Updated: </b> {{ $moment.unix(_.get(shareRecord, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Current Status: </b> {{ isShared ? 'Shared' : 'Not Shared' }}
        <br>
      </b-col>

      <b-col>
        <!--
        <b-form v-show="(!isShared && userCurrentContext.userMember.isOrgAdmin)  || userShareAllowedGroups(personOrganizationOwner).length > 1">
          <b-form-select
            :options="userGroups"
            v-model="userGroup"
            v-on:change="selectGroupHandler($event)"
            placeholder="Type to Search"
          >
            <template slot="first">
              <option :value="null" disabled>-- Please select a group --</option>
            </template>
          </b-form-select>
        </b-form>
        -->
        <!-- Already shared, so we're exposing options for Unsharing -->
        <b-form v-if="isShared && isAllowedToSharePerson">
          <b-form-checkbox
            id="fullUnShare"
            v-model="fullUnShare"
            name="fullUnShare"
            value="true"
            unchecked-value="false"
            switch
            inline
            disabled
            class="m-3"
          >
            Unshare all associated components of this person record (e.g. screenings, notes, advocates, and external ids).
          </b-form-checkbox>
        </b-form>
        <!-- Not shared, so we're exposing options for Sharing -->
        <b-form v-if="!isShared && isAllowedToSharePerson">
          <b-form-checkbox
            id="fullShare"
            v-model="fullShare"
            name="fullShare"
            value="true"
            unchecked-value="false"
            switch
            inline
            disabled
            class="m-3"
          >
            Share all associated records (e.g., screenings, notes, and advocates).
          </b-form-checkbox>
        </b-form>
      </b-col>
    </b-row>

    <b-alert
      dismissible
      fade
      :show="!_.isEmpty(sharePersonResponse)"
      :variant="sharePersonResponse.error ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage(sharePersonResponse)"></span>
    </b-alert>

    <b-alert
      dismissible
      fade
      :show="!_.isEmpty(unsharePersonResponse)"
      :variant="unsharePersonResponse.error ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage(unsharePersonResponse)"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button
          v-if="isAllowedToSharePerson"
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="shareHandler"
      >
        <span class="button-text">{{ isShared ? 'Unshare' : 'Share' }}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import userPermission from '@/mixins/userPermission'

export default {
  name: 'update-share-person-modal',
  mixins: [userPermission],
  props: {
    person: {
      type: Object,
      default () {
        return {}
      }
    },
    personId: Number,
    shareRecord: Object,
    personOrganizationOwner: Number,
    showModal: Boolean,
    selectedGroup: Object
  },
  components: {
  },
  data: function () {
    return {
      fullShare: true,
      fullUnShare: true,
      userSelection: false,
      userGroup: {}
    }
  },
  computed: {
    ...mapGetters({
      // userShareAllowedGroups: 'userShareAllowedGroups',
      userCurrentContext: 'userCurrentContext',
      getGroupsByOrg: 'getGroupsByOrg',
      unsharePersonResponse: 'unsharePersonResponse',
      sharePersonResponse: 'sharePersonResponse',
      sharePersonRecords: 'sharePersonRecords'
    }),
    isShared: function () {
      return _.get(this.shareRecord, 'personShareStatus', false)
    },
    userGroups: function () {
      const masterGrouplist = this.getGroupsByOrg
      const currentSharedRecords = this.sharePersonRecords
      let currentSharedGroups = currentSharedRecords.map((g) => g.sgroup.id)
      let filteredlist = []

      masterGrouplist.forEach((grp, i) => {
        var masterGroupId = grp.id
        var found = currentSharedGroups.includes(masterGroupId)
        if (!found) {
          filteredlist.push(grp)
        }
      })
      return filteredlist
    }
  },
  watch: {
    sharePersonResponse: function (newValue) {
      if (this.showModal && newValue.success) {
        _.delay(this.reset, 1000)
      }
    },
    unsharePersonResponse: function (newValue) {
      if (this.showModal && newValue.success) {
        _.delay(this.reset, 1000)
      }
    }
  },
  methods: {
    selectGroupHandler: function (group) {
      this.userSelection = true
      this.userGroup = group
    },
    shareHandler: function () {
      let params = {
        personId: this.personId,
        groupId: this.shareRecord.sgroup.id,
        orgId: this.userCurrentContext.organization.id
      }
      let self = this
      if (this.isShared) {
        this.$store.dispatch('unsharePerson', params).then(res => {
          if (this.unsharePersonResponse.success) {
            setTimeout(function () { self.$bvModal.hide('update-share-person') }, 2000)
          }
        })
      } else {
        this.$store.dispatch('sharePerson', params).then(res => {
          if (this.sharePersonResponse.success) {
            setTimeout(function () { self.$bvModal.hide('update-share-person') }, 2000)
          }
        })
      }
    },
    apiResponseMessage: function (response) {
      let message = response.message

      if (!response.success && response.error) {
        message = this.$utils.errorToHtml(response.error)
      }

      if (response.success) {
        message = 'Success!'
      }

      message = '<p>' + message + '</p>'
      return message
    },
    reset: function () {
      this.userSelection = false
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'sharePersonResponse' })
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'unsharePersonResponse' })
    }
  },
  mounted: function () {
    this.userGroup = this.selectedGroup
  },
  updated: function () {
    if (this.shareRecord) {
      this.userGroup = this.shareRecord.sgroup
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Share/UpdateSharePersonModal.vue